//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
import { Opaque } from '@utils/opaque';

type TimeZoneId = Opaque<string, 'TimeZoneId'>;

function TimeZoneIdFactory(timeZoneId: string) {
  return timeZoneId as TimeZoneId;
}

const TimeZoneId = Object.assign(TimeZoneIdFactory, {
  AmericaLosAngeles: TimeZoneIdFactory('America/Los_Angeles'),
  /**
   * UTC Timezone, compatible with moment-timezone
   */
  Utc: TimeZoneIdFactory('UTC'),
});

export default TimeZoneId;
